module.exports = __webpack_public_path__ + "img/img6.baefd5f4.svg";